
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("6AhPH", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-GB.277588f4.js.map
